var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-wrapper accent",style:({ height: _vm.height, width: _vm.width })},[_c('div',{staticClass:"progress-display",style:({
      height: _vm.progress + '%',
      background: _vm.$vuetify.theme.themes.light.primary,
    })}),_c('span',{staticClass:"progress-value",style:({ color: _vm.color, fontSize: _vm.fontSize })},[_vm._v(" "+_vm._s(Math.round(_vm.progress))+"% ")])])}
var staticRenderFns = []

export { render, staticRenderFns }